import React, { useState } from 'react';
import { Accordion, AccordionItem } from '../../../components/accordion';
import { ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { PurifiedHtmlContainer } from '../../../components/layout/purified-html-container';

const Content = React.memo(({ body, buttonEnabled, buttonOpenNewWindow, buttonLabel, buttonLink }) => (
  <>
    <PurifiedHtmlContainer html={body} className='typography typography-extended' />
    {buttonEnabled && (
      <ButtonWithIcon to={buttonLink} isExternal={buttonOpenNewWindow}>
        {buttonLabel}
      </ButtonWithIcon>
    )}
  </>
));

export const FAQ = React.memo(({ items }) => {
  const [state, setState] = useState({});

  const handleTrigger = key => () => {
    setState(value => ({ ...value, [key]: !value[key] }));
  };

  return (
    <Accordion>
      {items.map(({ title, ...item }) => (
        <AccordionItem key={title} title={title} expanded={state[title]} onClick={handleTrigger(title)}>
          <Content {...item} />
        </AccordionItem>
      ))}
    </Accordion>
  );
});
